export default __webpack_public_path__ + "static/media/elephant_NORMAL.5d1606cd.png";